import React from 'react'

import { useModal } from 'hooks'

// NOTE: hook that exposes edit evaluator modal state
// and handlers for other local hooks and interview components
export const useEditEvaluatorModal = (state, handlers) => {
  const { evaluator } = state
  const { handleSetEvaluatorId } = handlers

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleEditEvaluatorClose = React.useCallback(() => {
    handleSetEvaluatorId(null)
    handleClose()
  }, [handleClose, handleSetEvaluatorId])

  const handleEditEvaluatorOpen = React.useCallback(
    ({ uuid }) => {
      handleSetEvaluatorId(uuid)
      handleOpen()
    },
    [handleOpen, handleSetEvaluatorId],
  )

  const handleEditEvaluatorConfirm = React.useCallback(() => {
    // TODO: pass proper api handler
  }, [])

  return {
    handleEditEvaluatorClose,
    handleEditEvaluatorOpen,
    handleEditEvaluatorConfirm,
    isEditEvaluatorOpen: isOpen,
  }
}
